import React, { useMemo } from 'react';
import type { PapiNetworkbarStrip } from '@wix/da-papi-types';
import FeaturedShopsStrip from './FeaturedShopsStrip';
import PopularTopicsStrip from './PopularTopicsStrip';
import RecommendedSellStrip from './RecommendedSellStrip';

const codenameToComponent: {
  [key: string]: React.FC<{ strip: PapiNetworkbarStrip; className?: string }>;
} = {
  marketplace_recommended_to_sell: RecommendedSellStrip,
  marketplace_featured_shops: FeaturedShopsStrip,
  marketplace_top_topics: PopularTopicsStrip,
};

export function useStrips(strips: PapiNetworkbarStrip[] | undefined) {
  return useMemo(
    () =>
      strips?.map((strip, index) => {
        if (Object.keys(codenameToComponent).includes(strip.codename)) {
          const StripComponent = codenameToComponent[strip.codename];
          return (
            <StripComponent key={`${strip.codename}-${index}`} strip={strip} />
          );
        }
        return null;
      }),
    [strips]
  );
}
